<template>
  <div v-cloak>
    <section class="hero hero-page gray-bg padding-small">
      <div class="container">
        <div class="row d-flex">
          <div class="col-lg-9 order-2 order-lg-1">
            <h1>
              {{ printName }}&nbsp;&nbsp;
              <img alt="icon" class="img-fluid" :src="iconImage" />
            </h1>
            <h5>{{ $t('Styles') }}</h5>
            <p class="lead text-muted">
              {{ $t('ChooseAnyStyle') }}
            </p>
            <div v-if="showFavorite" class="list-inline-item">
              <FavoriteButton
                :is-favorite="isFavorite"
                item-type="print"
                :item-id="printId"
                :xsrf-token="xsrfToken"
              />
            </div>
          </div>
          <div class="col-lg-3 text-right order-1 order-lg-2">
            <ul class="breadcrumb justify-content-lg-end">
              <li class="breadcrumb-item">
                <a href="/">{{ $t('Home') }}</a>
              </li>
              <li class="breadcrumb-item">
                <a v-if="isSolid" href="/solids">{{ $t('Solids') }}</a>
                <a v-else href="/prints">{{ $t('Prints') }}</a>
              </li>
              <li class="breadcrumb-item active">{{ printName }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <ItemList :categories="categories" :items="items" filter-mode="and-or">
      <template #default="{ item }">
        <PrintWithStyleItem
          :item="item"
          :currency="currency"
          :display-currency="displayCurrency"
          :display-exchange-rate="displayExchangeRate"
          :culture="culture"
          :blob-domain="blobDomain"
        >
        </PrintWithStyleItem>
      </template>
    </ItemList>
  </div>
</template>

<script setup lang="ts">
import type Category from '../../common/Category';
import { type CatalogItem } from '../../common/CatalogItem';
import { computed } from 'vue';
import PrintWithStyleItem from '../../components/PrintWithStyleItem.vue';
import FavoriteButton from '../../components/FavoriteButton.vue';
import ItemList from '../../components/ItemList.vue';

const props = defineProps<{
  categories: Category[];
  items: CatalogItem[];
  currency: string;
  displayCurrency: string;
  displayExchangeRate: number;
  culture: string;
  blobDomain: string;
  isFavorite: boolean;
  printId: string;
  printName: string;
  iconImage: string;
  isAuthenticated: boolean;
  xsrfToken: string;
}>();

const isSolid = computed(() => props.printName === 'solid');
const showFavorite = computed(() => props.isAuthenticated && isSolid);
</script>
